/**
 * Keep-warm list for calls EVERY screen makes (L-0868 stage b). The keep-warm loop (hooks/useKeepWarm.ts) holds these warm
 * the whole time the app is open, for every signed-in user, whatever module they are in.
 *
 * driver_getMyVehicleEligibility: the top nav (components/Navigation.tsx -> hooks/driver/useMyVehicle.ts) reads it on every
 * screen, re-fetched once its 5-minute cache is stale; 34 cold waits of 416 real pre-flights over 2026-10-12..14, never
 * knocked. config/wake/appShell.ts leaves it out because a knock at mount lands with the call itself; the loop instead keeps
 * it warm BEFORE the next screen mounts, which is the case that one-shot list could not cover. Called through a wrapper
 * (lib/callableRetry.ts), so the page census cannot see it.
 */
export const WAKE_EVERY_SCREEN = {
  navigation: { enabled: true, callables: ['driver_getMyVehicleEligibility'] },
} as const;
